import React from "react";
import { Field } from "formik";

import { FormAutocomplete } from "../../../../../components/ui";
import { STATE_OPTIONS } from "../constants";

interface IProps {
  disabled: boolean;
}
const StateAutocomplete: React.FC<IProps> = ({ disabled }) => (
  <Field
    name="state"
    label="State"
    component={FormAutocomplete}
    options={STATE_OPTIONS}
    disabled={disabled}
  />
);

export default StateAutocomplete;
